import { useState } from "react";
import { AutoCompleteItem } from "../autocomplete/interface";
import { useQuery } from "@apollo/client";
import { KURSUS_BY_ID_TICKETDATA } from "../../api/kursus/queries";
import KursusIcon from "../icons/KursusIcon";
import AutoCompleteKursus from "../autocomplete/AutoCompleteKursus";
import ValidationErrorMessage from "./ValidationErrorMessage";
import FormControlButton from "../button/FormControlButton";
import IsRequired from "./common/IsRequired";

export default function KursusFormControl<U>({
  config,
  formik,
  value,
  disabled,
}: FormikKursusControlProps<U>) {
  const [selectedItem, setSelectedItem] = useState<
    AutoCompleteItem<number | void> | undefined
  >(undefined);
  const { setFieldValue, setFieldTouched, touched, errors } = formik;
  const { id, label, isRequired } = config;
  const removeKursus = () => {
    setShouldCaptureFocus(true);
    setFieldTouched(id, true);
    setFieldValue(id, undefined);
  };
  const { data, loading } = useQuery<{
    kursushold: {
      id: string;
      navn: string;
      holdNr: number;
      kursustype: number;
      fmukursusKategoriNavigation: {
        navn: string;
      };
    };
  }>(KURSUS_BY_ID_TICKETDATA, {
    variables: { id: value },
    skip: selectedItem !== undefined || !value,
  });
  const kursus = data ? data.kursushold : undefined;
  const qSelectedItem: AutoCompleteItem<number> | undefined = kursus
    ? {
        id: kursus.id,
        header: kursus.navn,
        subheader: `Holdnr: ${kursus.holdNr} | ${
          kursus.fmukursusKategoriNavigation.navn ?? ""
        }`,
        icon: <KursusIcon height={26} />,
        data: kursus.kursustype,
      }
    : loading
      ? {
          id: value ?? "",
          header: "Laster ...",
          subheader: "",
          icon: <KursusIcon height={26} />,
        }
      : undefined;

  const [shouldCaptureFocus, setShouldCaptureFocus] = useState(false);
  return (
    <>
      <label className="form-label" htmlFor={id}>
        {label}
        {isRequired && <IsRequired />}
      </label>
      {value && qSelectedItem && (
        <FormControlButton
          disabled={disabled}
          selectedItem={qSelectedItem}
          remove={removeKursus}
          shouldFocusOnMount={shouldCaptureFocus}
        />
      )}
      {value && selectedItem && !qSelectedItem && (
        <FormControlButton
          disabled={disabled}
          selectedItem={selectedItem}
          remove={removeKursus}
          shouldFocusOnMount={shouldCaptureFocus}
        />
      )}
      {!value && (
        <AutoCompleteKursus
          onInputBlur={() => {
            setFieldTouched(id, true);
          }}
          isInvalidClass={
            touched[id] && (errors as any)[id] ? "is-invalid" : ""
          }
          placeholder="Søg og vælg kursus ..."
          className="w-100"
          includeFirstItem={false}
          onSelectedItemChange={({ selectedItem }) => {
            if (selectedItem) {
              setShouldCaptureFocus(true);
              setFieldValue(id, selectedItem.id, true);
              if (config.checkIfExam) {
                setFieldValue("kursustype", selectedItem.data);
                if ((selectedItem.data as any) === 5) {
                  setFieldValue("overnatning", undefined);
                }
              }
              setSelectedItem(selectedItem);
            }
          }}
          focusInputOnMount={shouldCaptureFocus}
        />
      )}
      <ValidationErrorMessage
        touched={touched[id]}
        errorMessage={(errors as any)[id]}
      />
    </>
  );
}
